import React from 'react';
import '../index.less';
const User = (props) => {
  const user = sessionStorage.getItem('user');
  return (
    <div id='user' className='user'>
      {user}
      <div className='action'>
        <div onClick={props.changePwd}>修改密码</div>
        <div onClick={props.logout}>退出</div>
      </div>
    </div>
  );
}
export default User;